export default __webpack_public_path__ + "static/media/catlogo3.e43067a1.png";